import { ApolloError, useQuery } from '@apollo/client'
import { EmployeesWithHrOrDownloaderRoleQuery, EmployeesWithHrOrDownloaderRoleQueryVariables } from '../../../types'
import { EMPLOYEES_WITH_HR_OR_DOWNLOADER_ROLE } from '../Queries'

export default (): { data: EmployeesWithHrOrDownloaderRoleQuery | undefined; error: ApolloError | undefined; loading: boolean } => {
  const { data, error, loading } = useQuery<EmployeesWithHrOrDownloaderRoleQuery, EmployeesWithHrOrDownloaderRoleQueryVariables>(
    EMPLOYEES_WITH_HR_OR_DOWNLOADER_ROLE,
  )

  return { data, error, loading }
}
